import React from 'react';
import Footer from '../components/Footer';
import './LegalPages.css';

function TermsOfServicePage() {
    return (
        <div className="container legal-page">
            <h1>📄 Terms of Service</h1>
            <p className="effective-date"><strong>Effective Date: 28 May 2025</strong></p>
            
            <p>Welcome to MythicMaps. These Terms of Service ("Terms") govern your use of our platform. By using MythicMaps, you agree to be bound by these Terms and our Privacy Policy.</p>

            <h2>1. About Us</h2>
            <p>MythicMaps is a service provided by <strong>MythicMaps</strong>, a company registered in the United Kingdom (registration pending). You can reach us at <a href="mailto:data@mythicmaps.ai">data@mythicmaps.ai</a>.</p>

            <h2>2. Description of Service</h2>
            <p>MythicMaps enables you to:</p>
            <ul>
                <li>Import activity data from your Strava account (with your permission),</li>
                <li>Create stylized maps from your routes,</li>
                <li>Save, download, and share your map creations,</li>
                <li>Use a credit system to access map styles,</li>
                <li>Participate in challenges that track your cumulative Strava activity progress along a route.</li>
            </ul>

            <h2>3. Account and Credit Usage</h2>
            <ul>
                <li>You may be required to register or authenticate with Strava or email.</li>
                <li>Some features are available only with active credits.</li>
                <li>We may adjust credit policies or offerings, with notice.</li>
                <li>MythicMaps reserves the right to revoke access if terms are violated.</li>
            </ul>

            <h2>4. Your Responsibilities</h2>
            <p>You agree to:</p>
            <ul>
                <li>Provide accurate information,</li>
                <li>Use the service lawfully and respectfully,</li>
                <li>Not attempt to extract or replicate our software or styling models,</li>
                <li>Avoid uploading any content that violates intellectual property rights.</li>
            </ul>

            <h2>5. Intellectual Property</h2>
            <ul>
                <li>You retain ownership of your original activity data and map exports.</li>
                <li>MythicMaps retains rights to its branding, interface, and generative tools.</li>
                <li>By using our service, you grant us a license to use your data for service operation, improvement, and advertising purposes as described in these Terms.</li>
                <li>Unless you opt out, MythicMaps may showcase anonymized outputs for marketing or demonstration purposes.</li>
                <li>When you join a public challenge, your display name, profile photo, progress, and activity history will be visible to all visitors of that challenge page, including non-participants.</li>
            </ul>

            <h2>6. Advertising and Data Use</h2>
            <p>MythicMaps may display advertisements to support our service. By using our platform, you agree that we may:</p>
            <ul>
                <li>Display advertisements within the service interface,</li>
                <li>Use your profile information, activity data, and usage patterns to personalize and target advertisements,</li>
                <li>Share aggregated and anonymized data with advertising partners for targeting purposes,</li>
                <li>Work with third-party advertising networks that may use cookies and similar technologies to serve relevant ads.</li>
            </ul>
            <p>You may opt out of personalized advertising through your account settings or by contacting us directly. We never sell your personal data to third parties.</p>

            <h2>7. Privacy</h2>
            <p>Your data is handled according to our <a href="/privacy-policy">Privacy Policy</a> and <a href="/cookie-policy">Cookie Policy</a>.</p>
            <p>You control your consent and can delete your account and associated data at any time. When you delete your account, all your personal data will be permanently destroyed within 30 days.</p>

            <h2>8. Session Recording</h2>
            <p>We use PostHog for analytics and session recording to improve usability. These tools are GDPR-compliant, do <strong>not</strong> capture sensitive fields (passwords, payment details), and are strictly for internal analysis.</p>

            <h2>9. Availability and Changes</h2>
            <p>We aim for uninterrupted service but may perform maintenance or updates that temporarily impact availability. Features may change over time.</p>

            <h2>10. Termination</h2>
            <p>We reserve the right to suspend or terminate your account if you breach these Terms. You may delete your account at any time by contacting <a href="mailto:data@mythicmaps.ai">data@mythicmaps.ai</a>.</p>
            <p><strong>Data deletion:</strong> Upon account deletion, all your personal data will be permanently destroyed within 30 days.</p>

            <h2>11. Limitation of Liability</h2>
            <p>The stylized maps are for visual and personal use only. We are not liable for any decisions made based on the generated content or service interruptions.</p>

            <h2>12. Governing Law</h2>
            <p>These Terms are governed by the laws of <strong>England and Wales</strong>. Disputes will be subject to the jurisdiction of UK courts.</p>

            <div className="contact-section">
                <p><strong>Need Help?</strong></p>
                <p>Email: <a href="mailto:data@mythicmaps.ai">data@mythicmaps.ai</a></p>
            </div>
            <Footer />
        </div>
    );
}

export default TermsOfServicePage;

